export default "__VITE_ASSET__1041265e__"